/* eslint-disable react/prop-types */
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const DevStandardDropdown = ({ onChange, value }) => {

  return (
    <FormControl className={'w-full'}>
      <InputLabel id="type-route-label">Type</InputLabel>
      <Select
        labelId="type-route-label"
        value={value}
        onChange={onChange}
        fullWidth>
        <MenuItem value={'DEV'}>DEV</MenuItem>
      </Select>
    </FormControl>
  );
};

export default DevStandardDropdown;
